import React from 'react';
import { motion } from 'framer-motion';

import { sanitizeHtml } from 'utils';

import image_1 from '../../../../../asset/resource/pillar-image-1.png';
import image_2 from '../../../../../asset/resource/pillar-image-2.png';
import image_3 from '../../../../../asset/resource/pillar-image-3.png';
import image_4 from '../../../../../asset/resource/pillar-image-4.png';
import image_1m from '../../../../../asset/resource/pillar-image-1-mobile.png';
import image_2m from '../../../../../asset/resource/pillar-image-2-mobile.png';
import image_3m from '../../../../../asset/resource/pillar-image-3-mobile.png';
import image_4m from '../../../../../asset/resource/pillar-image-4-mobile.png';

import './PillarsOfEnergy.scss';

const images = [image_1, image_2, image_3, image_4];
const mobileImages = [image_1m, image_2m, image_3m, image_4m];

const PillarsOfEnergy = ({ data }) => {
  const { heading, items } = data;
  const parsedItems = items.map((element, idx) => ({
    ...element,
    image: images[idx],
    mobileImage: mobileImages[idx],
  }));

  return (
    <div className="pillars">
      <div className="wrapper">
        <h2 className="pillars__title" dangerouslySetInnerHTML={{ __html: sanitizeHtml(heading) }} />
        <div className="pillars__list">
          {parsedItems.map(({ image, mobileImage, heading, subHeading, content }, idx) => (
            <div key={heading} className={`pillars__item ${idx % 2 === 1 ? 'pillars__item_reversed' : ''}`}>
              <div className="pillars__item-text">
                <div className="pillars__item-heading">
                  <h3
                    dangerouslySetInnerHTML={{
                      __html: sanitizeHtml(heading),
                    }}
                  />
                </div>
                <h4>{subHeading}</h4>
                <div
                  className="pillars__item-points"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(content),
                  }}
                />
              </div>
              <motion.div
                initial={{ opacity: 0, y: 400 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ type: 'anticipate', duration: 1.5 }}
                className="pillars__image-wrapper"
              >
                <motion.img
                  initial={{ scale: 0.8 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    type: 'anticipate',
                    duration: 1.5,
                    delay: 1.5,
                  }}
                  src={image}
                />
                <motion.img
                  initial={{ scale: 0.8 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{
                    type: 'anticipate',
                    duration: 1.5,
                    delay: 1.5,
                  }}
                  className="mobile-image"
                  src={mobileImage}
                />
              </motion.div>
            </div>
          ))}
          {/* <div className="pillars__item">
            <div className="pillars__item-text">
              <div className="pillars__item-heading">
                <div className="pillars__image-wrapper pillars__image-wrapper_mobile ">
                  <img src={image_1} />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(firstItem.heading),
                  }}
                />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(firstItem.content),
                }}
              />
            </div>
            <div className="pillars__image-wrapper">
              <img src={image_1} />
            </div>
          </div>

          <div className="pillars__item pillars__item_reversed">
            <div className="pillars__image-wrapper">
              <img src={image_2} />
            </div>
            <div className="pillars__item-text">
              <div className="pillars__item-heading">
                <div className="pillars__image-wrapper pillars__image-wrapper_mobile ">
                  <img src={image_2} />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(secondItem.heading),
                  }}
                />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(secondItem.content),
                }}
              />
            </div>
          </div>

          <div className="pillars__item">
            <div className="pillars__item-text">
              <div className="pillars__item-heading">
                <div className="pillars__image-wrapper pillars__image-wrapper_mobile ">
                  <img src={image_3} />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(thirdItem.heading),
                  }}
                />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(thirdItem.content),
                }}
              />
            </div>
            <div className="pillars__image-wrapper">
              <img src={image_3} />
            </div>
          </div>

          <div className="pillars__item pillars__item_reversed">
            <div className="pillars__image-wrapper">
              <img src={image_4} />
            </div>
            <div className="pillars__item-text">
              <div className="pillars__item-heading">
                <div className="pillars__image-wrapper pillars__image-wrapper_mobile ">
                  <img src={image_4} />
                </div>
                <h3
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(fourthItem.heading),
                  }}
                />
              </div>
              <p
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(fourthItem.content),
                }}
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PillarsOfEnergy;
